<template>
  <div class="add-imprinta-printer">
    <h4 class="text-center mb-2 mt-2">{{$t('printers.modal.add_imprinta_printer.title')}}</h4>
    <b-row class="add-printer-block">
      <b-col sm="12" lg="3" class="printer-image d-none d-lg-flex">
        <div>
          <svg clip-rule="evenodd" fill-rule="evenodd" height="100" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 100 100" width="100" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke-miterlimit="2.61313"><g stroke="#2cb894"><path d="m35.14 29.34h30.27v34.93h-30.27z" stroke-width="2"/><path d="m28.23 29.34h44.11v53.07h-44.11z" stroke-width="2.08"/><path d="m43.37 69.85h13.81v6.38h-13.81z" stroke-width="2"/></g><g stroke="#373435" stroke-width="2.08"><path d="m45.32 39.05h9.92v6.36h-9.92z"/><path d="m50.28 45.41v6.36"/><path d="m78.56 9.63v13.36"/><path d="m85.24 16.31h-13.35"/><path d="m86.61 20.91v5.53"/><path d="m89.37 23.68h-5.52"/><path d="m84.43 52.75v8.38"/><path d="m88.62 56.94h-8.38"/><path d="m12.41 37.4v8.36"/><path d="m16.59 41.58h-8.36"/></g></g></svg>
        </div>
      </b-col>
      <b-col sm="12" lg="9" class="add-printer-content">
        <div class="add-printer-serial">
          <section v-if="!serialNumber">
            <p class="text-center mb-2">
              {{$t('printers.modal.add_imprinta_printer.enter_serial_number')}}
            </p>
            <b-form-group class="text-center serial">
              <b-form-input class="inp" :placeholder="$t('printers.modal.add_imprinta_printer.serial_number')" type="text" v-model="serialValue"></b-form-input>
              <b-button variant="-secondary" class="ml-2" @click="handleSendSerialNumber"><font-awesome-icon icon="arrow-right"></font-awesome-icon></b-button>
            </b-form-group>
            <p v-if="error" class="text-center text-danger">
              {{this.error}}
            </p>
          </section>
          <section v-else-if="addedPrinterHash && !activated">
            <p class="text-center" v-html="$t('printers.modal.add_imprinta_printer.activate_printer', {hash: addedPrinterHash})"></p>
          </section>
          <section v-else>
            <p class="text-center" v-html="$t('printers.modal.add_imprinta_printer.printer_added')"></p>
            <p class="text-center mt-4">
              <b-button variant="-primary" size="-lg" @click="$emit('close')">{{$t('buttons.close')}}</b-button>
            </p>
          </section>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: 'add-new-imprinta-printer',
    data() {
      return {
        serialValue: null,
        serialNumber: null,
        processing: false,
        error: null,
        addedPrinterHash: null
      }
    },
    computed: {
      ...mapGetters(['getPrinterBySerialNumber']),

      activated() {
        if (!this.serialNumber) {
          return false;
        }

        return this.getPrinterBySerialNumber(this.serialNumber) !== undefined;
      }
    },
    methods: {
      ...mapActions(['addNewImprintaPrinter']),

      handleSendSerialNumber() {
        this.processing = true;
        this.error = null;
        this.addNewImprintaPrinter(this.serialValue).then(({data}) => {
          this.processing = false;
          if (data.result) {
            if (data.message && data.message.hash) {
              this.addedPrinterHash = data.message.hash;
            }
            this.serialNumber = this.serialValue;
          } else {
            if (data.message.trim() === 'Wrong serialnumber') {
              this.error = this.$t('printers.modal.add_imprinta_printer.wrongSerialNumber');
            } else if (data.message.trim() === 'This serialnumber was already registered') {
               this.error =  this.$t('printers.modal.add_imprinta_printer.serialnumberWasRegistered');
            } else {
              this.error = data.message;
            }
          }
        }).catch(e => {
          console.log(e);
          this.error = this.$t('printers.modal.add_imprinta_printer.failedToAdd');
          this.processing = false;
        })
      }
    }
  }
</script>

<style lang="scss">
  .add-imprinta-printer {
    .add-printer-block{
      height: 100%;
      min-height: 230px;
      border-top: 1px solid #e8e8e8;
      margin-top: 20px;
      .printer-image {
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0px 0px -12px -5px;
        border-radius: 0 0 0 8px;

        svg {
          height: 120px;
          width: 120px;
          padding-bottom: 5px;
          margin: 40px;
        }
      }
      .add-printer-content{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .add-printer-serial{
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .inp{
            max-width: 310px;
            width: 100%;
          }
        }
      }
    }
  }
  .printer-pin-code {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: 3px;
    margin-top: 10px;
  }
.serial{
  div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
